import { Button, ButtonGroup, Modal } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';

import React from 'react';
import I9Constants from '../I9Constants/I9Constants';

export type I9CancelModalProps = {
  isOpen: boolean;
  close(): void;
  onLogout(): void;
};

const I9CancelModal = ({ isOpen, close, onLogout }: I9CancelModalProps): JSX.Element => {
  const modalId = 'i9-cancel-modal';

  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
  Modal.setAppElement('#root');

  const handleClose = (): void => {
    close();
  };

  return (
    <Modal
      id={modalId}
      header="Are you sure you want to leave this page?"
      open={isOpen}
      close={handleClose}
      hasDismissButton={false}
      fixedToTop
    >
      <Modal.Content>
        <Alert status="warning">
          <Alert.Heading>
            {I9Constants.PROGRAM_NAME} training must be completed to gain access to E-Verify.
          </Alert.Heading>
          <Alert.Text>
            To continue your training with {I9Constants.PROGRAM_NAME}, select &lsquo;Stay on Page&lsquo;. To leave page,
            select &lsquo;Yes, Leave Page & Sign Out&lsquo;.
          </Alert.Text>
        </Alert>
      </Modal.Content>
      <Modal.Footer>
        <ButtonGroup>
          <Button type="button" variant="secondary" onClick={handleClose} aria-label="Stay on Page" data-close-modal>
            Stay on Page
          </Button>
          <Button type="button" variant="primary" onClick={onLogout} aria-label="Yes, Leave Page & Sign Out">
            Yes, Leave Page & Sign Out
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default I9CancelModal;
